import React from 'react';
import HeaderCell from './HeaderCell';
import ZCell from './ZCell';


class Row extends React.Component {
    render() {
        const cells = this.props.numbers.map((number, index) => {
            // Build Header Cell with ones and tenths place of z-score input
            if (this.props.type === "head" || index === 0) {
                return (
                    <HeaderCell
                        key={index - 1}
                        column={index - 1}
                        value={number}
                    />
                );
            }
            // Build Data Cell which holds z-value of target z-score
            else {
                return (
                    <ZCell
                        key={index - 1}
                        value={number}
                        flag={this.props.flags[index - 1]}
                    />
                );
            }
        });

        // Build Row
        return (
            <tr>{cells}</tr>
        );
    }
}

export default Row;